import { useFileDownload, useFilePreview } from 'api/requests';
import { lodash, openAsyncLink } from 'helpers';
import { useAccountDocuments } from 'hooks/account';
import { useTranslation } from 'libs/i18n';
import { DocumentsListItem } from 'modules/account/common/components/DocumentsTable/types';

export const useDocuments = () => {
  const { t } = useTranslation();

  const { getFileLink: getPreviewFileLink } = useFilePreview();
  const { getFileLink: getDownloadFileLink } = useFileDownload();

  const { documents: accountDocuments, loading } = useAccountDocuments();

  const documents: DocumentsListItem[] = lodash
    .compact(accountDocuments)
    .map((doc) => ({
      id: doc.id,
      size: doc.size,
      name: t(`onboarding.fileTypeName.${doc.type}`),
    }));

  const onClickDownload = async (item: DocumentsListItem) => {
    openAsyncLink(() => getDownloadFileLink(item.id));
  };
  const onClickPreview = async (item: DocumentsListItem) => {
    openAsyncLink(() => getPreviewFileLink(item.id));
  };

  return {
    documents,
    loading,
    onClickDownload,
    onClickPreview,
  };
};
